import React from 'react';
import { Button, Popconfirm } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';

import InfoItem from '../DevicesPage/InfoBlocks/InfoItem';
import { StatusIcon } from '@components/icons';

const DeleteIcon = () => <DeleteOutlined />;
const AddIcon = () => <PlusOutlined />;

function CalendarDeviceItem({
  t,
  id,
  name,
  lastOnline,
  calendar,
  deleteAction,
  selectedIds,
  onClick,
}) {
  return (
    <div className="cal-device-item">
      <div className="cal-device-item__status">
        <InfoItem
          icon={<StatusIcon />}
          color={lastOnline ? 'danger' : 'success'}
        />
      </div>
      <div className="cal-device-item__name">{name}</div>
      {deleteAction ? (
        <Popconfirm
          placement="left"
          title={t('delete-device-warning')}
          cancelText={t('to-leave')}
          okText={t('delete')}
          onConfirm={onClick(id)}
        >
          <Button type="link" icon={<DeleteIcon />} />
        </Popconfirm>
      ) : !isEmpty(calendar) && !includes(selectedIds, id) ? (
        <Popconfirm
          placement="left"
          title={t('device-busy')}
          cancelText={t('cancel')}
          okText={t('yes')}
          onConfirm={onClick(id)}
        >
          <Button
            type="link"
            icon={includes(selectedIds, id) ? <DeleteIcon /> : <AddIcon />}
          />
        </Popconfirm>
      ) : (
        <div className="cal-device-item__action">
          <Button
            type="link"
            onClick={onClick(id)}
            icon={includes(selectedIds, id) ? <DeleteIcon /> : <AddIcon />}
          />
        </div>
      )}
    </div>
  );
}

export default CalendarDeviceItem;
